// libraries
import styled from 'styled-components';

// package.json
import packageJson from '../../../../package.json';

const VersionContainer = styled.div`
  position: fixed;
  bottom: 16px;
  right: 16px;
  padding: 8px 12px;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  z-index: 1000;
  pointer-events: none;
  user-select: none;
`;

export const VersionTag = () => {
  return (
    <VersionContainer data-testid="version-tag">
      v{packageJson.version}
    </VersionContainer>
  );
};
